/* global window */

import _ from 'lodash';
import { COUPON_CHECK_WAIT, EMAIL_CHECK_WAIT } from '../../store/constants';
import UploadPhoto from '../upload-photo/upload-photo.vue';

const ENTITY_TYPE = 'p';

export default {
  components: { UploadPhoto },
  props: {
    activeBrandId: { type: Number, required: true },
    hasActiveRandomCampaigns: { type: Boolean, required: true },
    code: { type: String, required: false },
    name: { type: String, required: false },
    email: { type: String, required: false },
  },
  data() {
    return {
      campaignId: null,
      coupon: {},
      couponCode: '',
      emailVacancies: [],
      errorExchanging: null,
      exchangingCoupon: false,
      form: {
        name: '',
        email: '',
        projectId: null,
      },
      loadingCoupon: false,
      projectFixedByCoupon: null,
      uploadStatus: false,
      uploadError: [],
      preview: null,
    };
  },
  computed: {
    showEmailUnavailableError() {
      return this.emailFormatValid && !this.isEmailUsable && this.hasActiveRandomCampaigns;
    },
    emailFormatValid() {
      return !_.isEmpty(this.form.email) && !this.errors.has('project-id');
    },
    isEmailUsable() {
      return this.validCouponCode || this.emailVacancies.find(obj => obj.vacant) !== undefined;
    },
    isFormComplete() {
      return this.form.name !== '' && this.form.email !== '' && this.form.projectId !== null &&
        this.isImageUploaded && this.isEmailUsable;
    },
    isImageUploaded() {
      return this.uploadStatus === 'uploaded';
    },
    validCouponCode() {
      return !_.isEmpty(this.coupon) && this.coupon.available;
    },
  },
  methods: {
    checkAndEnableUpload(selectedFile) {
      if (selectedFile.errors.length) {
        this.uploadError = selectedFile.errors;
      } else {
        this.uploadStatus = 'ready';
        this.uploadError = [];
      }
    },
    checkCouponCode: _.debounce(
      function () {
        this.loadingCoupon = true;
        this.$store.dispatch('checkCoupon', { couponCode: this.couponCode.toUpperCase() })
          .then(coupon => {
            this.loadingCoupon = false;
            this.updateCoupon(coupon);
          });
      },
      COUPON_CHECK_WAIT,
      {
        leading: true,
      }
    ),
    checkEmail: _.debounce(
      function () {
        if (!this.validCouponCode && this.form.email !== '') {
          this.$store.dispatch('checkEmailVacancies', {
            brandId: this.activeBrandId,
            projectId: this.form.projectId,
            email: this.form.email,
          })
            .then(vacancies => { this.emailVacancies = vacancies; });
        } else {
          this.emailVacancies = [];
          this.campaignId = null;
        }
      },
      EMAIL_CHECK_WAIT,
      {
        leading: true,
      }
    ),
    getAvailableProjects() {
      let projects = null;
      if (this.validCouponCode) {
        projects = this.$store.getters.projects(this.projectIdsByCoupon);
      } else if (this.isEmailUsable) {
        projects = this.getProjectsByVacancies();
      } else {
        projects = [];
      }

      return projects;
    },
    getProjectsByVacancies() {
      let projects = null;
      const vacancies = this.emailVacancies.filter(vacancy => vacancy.vacant);
      if (vacancies.find(vacancy => _.isEmpty(vacancy.projectIds))) {
        projects = this.$store.getters.randomDistProjects(null);
      } else {
        const projectIds = vacancies.reduce((acc, vacancy) => acc.concat(vacancy.projectIds), []);
        projects = this.$store.getters.randomDistProjects(projectIds);
      }

      return projects;
    },
    getPurchaseParams() {
      const purchase = {
        projectId: this.form.projectId,
        name: this.form.name,
        email: this.form.email,
        uploadIdentifier: this.form.uploadIdentifier,
        entityType: ENTITY_TYPE,
        entitySlug: this.$store.getters.project(this.form.projectId).slug,
      };

      if (this.validCouponCode) {
        purchase.couponId = this.coupon.id;
      } else {
        purchase.campaignId = this.emailVacancies.find(vacancy =>
          _.isEmpty(vacancy.projectIds) || vacancy.projectIds.includes(this.form.projectId)
        ).campaignId;
      }

      return purchase;
    },
    dispatchExchange() {
      this.exchangingCoupon = true;
      this.errorExchanging = false;
      this.$store.dispatch('exchangePurchase', this.getPurchaseParams())
        .then(response => {
          window.location.href = response.purchase.fullMapPath;
          this.exchangingCoupon = false;
        })
        .catch(err => {
          this.exchangingCoupon = false;
          this.errorExchanging = err;
        });
    },
    updateCoupon(coupon) {
      this.projectIdsByCoupon = null;
      if (coupon) {
        this.coupon = coupon;
        if (!_.isEmpty(this.coupon.projects)) {
          this.projectIdsByCoupon = this.coupon.projects.map(project => project.id);
          this.form.projectId = this.projectIdsByCoupon[0];
        }
      } else {
        this.coupon = null;
      }
    },
    submitCoupon() {
      this.$validator.validateAll()
        .then((result) => {
          if (result && this.coupon) {
            this.dispatchExchange();
          } else {
            console.log('Corrects errors before submitting.');
          }
        });
    },
    uploadDone() {
      this.uploadStatus = 'uploaded';
    },
    changePreview(preview) {
      this.preview = preview;
    },
  },
  beforeMount() {
    this.$store.dispatch('initProjectsProfile', { brandId: this.activeBrandId });
  },
  mounted() {
    if (this.code) {
      this.couponCode = this.code;
      this.checkCouponCode();
    }
    if (this.name) {
      this.form.name = this.name;
    }
    if (this.email) {
      this.form.email = this.email;
    }
  },
};
